export const TOKEN = 'mwell-md-token';
export const CURRENT_USER = 'mwell-md-current-user';
export const TELEMED_CRED = 'mwell-md-telemed-credentials';
export const ON_CALL= 'mwell-md-on-call';
export const ADB2C_CODE= 'mwell-md-adb2-code';